import {createReducer, on} from "@ngrx/store";
import {setIncludePartnersStore} from "./include-partners.action";

const initialState = true;

export const includePartnersReducer = createReducer(
  initialState,
  on(setIncludePartnersStore, (state, action) => state = action.value),
);
